import { MenuItem } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function LibraryViewOption({ item }) {
    const { selectedView, onSelectOption } = useBoundContext()

    return (
        <MenuItem data-cy={item.dataCy} selected={selectedView === item.value} onClick={handleClick}>
            {item.label}
        </MenuItem>
    )

    function handleClick() {
        onSelectOption(item.value)
    }
}
